import { render, staticRenderFns } from "./recordother.vue?vue&type=template&id=4a207fde&scoped=true&"
import script from "./recordother.vue?vue&type=script&lang=js&"
export * from "./recordother.vue?vue&type=script&lang=js&"
import style0 from "./recordother.vue?vue&type=style&index=0&id=4a207fde&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a207fde",
  null
  
)

export default component.exports